import { FileMimeType } from "@core/types";

export const MagicNumberBytePattern = {
    image: {
        '89504E47': FileMimeType.PNG,
        'FFD8FF': FileMimeType.JPEG
    },
    map: {
        '3C3F786D': FileMimeType.KML,
    },
    firmware: {
        '32524448': FileMimeType.AFW
    },
    configuration: {
        '3C524F4D46494C453E': FileMimeType.CFG
    }
};